import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { track } from '../utils/analytics'
import { normalizeSearchTerm } from '../core/rules/insights/searchTerms'

/** Zo lang stil na typen voordat een zoekterm telt: geen halve woorden per toetsaanslag. */
export const SEARCH_IDLE_MS = 1200

/**
 * Telt een zoekterm in de webshop één keer per paginabezoek, pas na een korte stilte, en alleen
 * als hij mag (core/rules/insights/searchTerms.ts). Met het aantal resultaten, zodat Inzicht
 * "zonder resultaat" kan tonen.
 */
export function useSearchTracking(term: string, results: number) {
  const { pathname } = useLocation()
  const sent = useRef(new Set<string>())

  useEffect(() => {
    sent.current = new Set()
  }, [pathname])

  useEffect(() => {
    const clean = normalizeSearchTerm(term)
    if (!clean || sent.current.has(clean)) return
    const timer = window.setTimeout(() => {
      sent.current.add(clean)
      track('zoeken', { term: clean, resultaten: results })
    }, SEARCH_IDLE_MS)
    return () => window.clearTimeout(timer)
  }, [term, results])
}
